<template>
  <div v-if="isShowPage" class="history">
    <div class="col-header">
      <!-- 导航 -->
      <van-nav-bar left-text :right-text="clearText" left-arrow @click-left="onClickLeft" @click-right="onClear" />
      <!-- tab按钮 -->
      <div class="col-tab">
        <span :class="{ active: showTab === 1 }" @click="changeTab(1)">{{ lang.esSale }}</span>
        <span :class="{ active: showTab === 2 }" @click="changeTab(2)">{{ lang.rent }}</span>
        <span :class="{ active: showTab === 3 }" @click="changeTab(3)">{{ lang.newSale }}</span>
        <span :class="{ active: showTab === 4 }" @click="changeTab(4)">{{ lang.estate }}</span>
      </div>
    </div>
    <!-- tab切换列表 -->
    <div>
      <iframe :src="base+'/estate/'" frameborder="0" style="display: none;"></iframe>
      <iframe :src="base" frameborder="0" style="display: none;"></iframe>
      <iframe :src="baseH" frameborder="0" style="display: none;"></iframe>
      <!-- <van-loading color="#1989fa" class="loading" v-if="i" /> -->
      <div class="none-record" v-if="showTab === 1 ? buyNull : showTab === 2 ? rentNull : showTab === 3 ? newNull : estNull">
        <img src="//static.house730.com/m/images/none_history.png" :alt="lang.noInfo" class="none_col" />
        <p>{{ lang.noInfo }}</p>
      </div>
      <div v-else>
        <historyList v-show="showTab === 1" :houseList="BuyHistoryList" :relatedList = "'history'"></historyList>
        <historyList v-show="showTab === 2" :houseList="RentHistoryList" :relatedList = "'history'"></historyList>
        <newList v-show="showTab === 3" :houseList="NewHistoryList" @newCollection="newCollection" @cancelCollection="cancelCollection" :relatedList = "'history'"></newList>
        <estList v-show="showTab === 4" :houseList="estateHistoryList" @newCollection="newCollection" @cancelCollection="cancelCollection" :relatedList = "'history'"></estList>
        <van-loading color="#1989fa" class="loading" v-if="showTab === 1 && !showBuy " />
        <van-loading color="#1989fa" class="loading" v-if="showTab === 2 && !showRent " />
        <van-loading color="#1989fa" class="loading" v-if="showTab === 3 && !showNew " />
        <van-loading color="#1989fa" class="loading" v-if="showTab === 4 && !showEst " />
      </div>
    </div>

    <!-- 点击清除出现的蒙版 -->
    <van-dialog
      v-model="showClear"
      :title="lang.messageTit"
      show-cancel-button
      :confirmButtonText="lang.confirmButtonText"
      :cancelButtonText="lang.cancelButtonText"
      :overlay="false"
      :beforeClose="beforeClose"
    ></van-dialog>
    <div class="popup-clear" v-show="showClear"></div>

    <!-- 筛选 -->
    <!-- <div class="col-choice" @click="getChoice" v-show="false">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-shaixuanx"></use>
      </svg>
      筛选
    </div>-->
    <!-- 筛选弹出框 -->
    <!-- <van-popup v-model="show" position="bottom" :overlay="true" :overlay-style="popupColor" v-show="false">
      <p
        :class="['choice-house choice-border',{'choice-active':active==='residence'}]"
        @click="choiceHouse('residence')"
      >{{lang.residential}}</p>
      <p
        :class="['choice-house',{'choice-active':active==='business'}]"
        @click="choiceHouse('business')"
      >{{lang.offices}}</p>
    </van-popup>-->
  </div>
</template>

<script>
import pub from '../../common/public';
// import { Toast } from 'vant';
import '../../common/css/common.scss';
import lang from './../../common/language/history';
import historyList from '../components/history-list';
import newList from '../components/new-list';
import estList from '../components/est-list';
const _conf = require('../../common/js/_conf');
export default {
  metaInfo: { title: lang.browseHistory },
  name: 'history',
  data() {
    return {
      isShowPage: false,
      isPc: false,
      lang: lang,
      showTab: 1,
      // showTab: 1,
      BuyHistoryList: [], // 楼盘列表数据
      RentHistoryList: [],
      NewHistoryList: [],
      estateHistoryList: [],
      clearText: '',
      showClear: false, //显示清除弹窗
      buyNull: false, //是否展示空白
      rentNull: false,
      newNull: false,
      estNull: false,
      // estateButton: false,
      baseH:'',
      base:'',
      showBuy: false,
      showRent: false,
      showNew: false,
      showEst: false,
      // show:false,//显示筛选弹窗
      // showChoice: true, // 是否显示筛选按钮
      // active: "",       // 筛选类型选择
      // popupColor: {  // 筛选背景蒙版颜色
      //   "background-color": "rgba(0,0,0,0.35)"
      // },
    };
  },
  components: {
    // [Toast.name]: Toast,
    historyList,
    newList,
    estList,
  },
  created() {
    this.baseH = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
    this.base = _conf.env_type == 4 ? 'https://simm.house730.com':_conf.env_type == 3 ?'https://m.house730.com':'https://uatm.house730.com.cn'
    this.isShowPage = true;
    // let estateB = JSON.parse(sessionStorage.getItem("estate_switch"));
    // if(estateB == 1){
    //   this.estateButton = !this.estateButton;
    // }else{
    //   this.estateButton = this.estateButton;
    // }
    this.showTab = this.$route.query.type === 'newEstate' ? 3 : this.$route.query.type === 'rent' ? 2 : this.$route.query.type === 'estate' ? 4  : 1;
  },
  mounted() {
    // window.parent.postMessage(localStorage.getItem('isDel'), 'https://uatm.house730.com.cn/estate/');
    window.addEventListener('message', async (event) =>{
      if (event.origin === this.base || event.origin === this.baseH) {
          // console.log("event.origin:",event.origin)
          // console.log("this.base:",this.base)
          // console.log("event:",event)
          // console.log("event.data:",event.data)
          // console.log("true or false:",Array.isArray(event.data) && event.data.length)
        if(Array.isArray(event.data) && event.data.length > 0){
            for (let index = 0; index < event.data.length; index++) {
              localStorage.setItem(event.data[index].type, event.data[index].obj);
              console.log("setItem",localStorage.getItem(event.data[index].type))
              await this.getHistoryList(event.data[index].type);
            }
            this.showClearText();
          }
        }
    });
   
      // this.getHistoryList('BuyHistoryList');
      // this.getHistoryList('RentHistoryList');
      // this.getHistoryList('NewHistoryList');
      // this.getHistoryList('estateHistoryList');
      // this.showClearText();
  },
  methods: {
    // 导航返回按钮
    onClickLeft() {
      if (!this.showClear) {
        this.$router.go(-1);
      }
    },
    // tab切换
    changeTab(sell) {
      if (!(this.showClear || this.showTab === sell)) {
        this.showTab = sell;
        this.showClearText();
      }
    },
    // 获取历史记录数据
    getHistoryList(type) { 
      return new Promise((res,rej)=>{
        // debugger
        let houseList = [];
        if (localStorage.getItem(type) && localStorage.getItem(type)!= 'null') {
          houseList = JSON.parse(localStorage.getItem(type))
          type === 'BuyHistoryList' ? (this.showBuy = true) : type === 'RentHistoryList' ? (this.showRent = true) : type === 'estateHistoryList' ? (this.showEst = true) : ( this.showNew = true);
        } else {
          houseList = [];
          type === 'BuyHistoryList' ? (this.showBuy = true,this.buyNull = true) : type === 'RentHistoryList' ? (this.showRent = true,this.rentNull = true) : type === 'estateHistoryList' ? (this.showEst = true,this.estNull = true) : ( this.showNew = true,this.newNull = true);
        }
        if (type === 'BuyHistoryList') {
          this.BuyHistoryList = houseList;
        } else if (type === 'RentHistoryList') {
          this.RentHistoryList = houseList;
        } else if (type === 'estateHistoryList') {
          this.estateHistoryList = houseList;
        } else {
          this.NewHistoryList = houseList;
        }
        res()
      })     
    },

    // 是否显示清除文案和Toast
    showClearText() {
      if (this.showTab === 1 && !this.buyNull && this.showBuy) {
        const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
        this.clearText = this.lang.clear;
        if(token){
          if (this.isShowPage && this.BuyHistoryList.length) {
            this.$toast(this.lang.find + this.BuyHistoryList.length + this.lang.properties);
          }
        }
      } else if (this.showTab === 2 && !this.rentNull && this.showRent) {
        this.clearText = this.lang.clear;
        if (this.isShowPage && this.RentHistoryList.length) {
          this.$toast(this.lang.find + this.RentHistoryList.length + this.lang.properties);
        }
      } else if (this.showTab === 3 && !this.newNull && this.showNew) {
        this.clearText = this.lang.clear;
        if (this.isShowPage && this.NewHistoryList.length) {
          this.$toast(this.lang.find + this.NewHistoryList.length + this.lang.properties);
        }
      } else if (this.showTab === 4 && !this.estNull && this.showEst) {
        this.clearText = this.lang.clear;
        if (this.isShowPage && this.estateHistoryList.length) {
          this.$toast(this.lang.find + this.estateHistoryList.length + this.lang.wuEst);
        }
      } else {
        this.clearText = '';
      }
    },
    // 清空历史纪录
    onClear() {
      this.showClear = true;
    },
    listCount(){
      let data = [
        { type: 'BuyHistoryList', count: 0},
        { type: 'RentHistoryList', count: 0},
        { type: 'NewHistoryList', count: 0},
        { type: 'estateHistoryList', count: 0}
      ]
      // let data = 'aaa'
      let val = JSON.stringify(data)
      this.setDel('deleteCount',val)
      // this.pub.setCookie('deleteCount',val)
      // localStorage.setItem("isDel",JSON.stringify(data))
    },
    setDel(key,value,expires){
      console.log("_conf.env_type",_conf.env_type)
      const date = expires ? new Date(expires * 1000) : new Date('9999-12-31');
      document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/;domain=${(_conf.env_type == 4 || _conf.env_type == 3)? 'house730.com' : 'house730.com.cn'};${(_conf.env_type == 4 || _conf.env_type == 3) ? 'secure=true' : ''}`;
    },
    getDel(name){
      let arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    countUp(type){
      // let delCount = JSON.parse(localStorage.getItem('isDel'));
      let delCount = JSON.parse(this.getDel('deleteCount'));
      console.log("type:",type)
      console.log("delCount:",delCount)
      for (let i = 0; i < delCount.length; i++) {
        if(type == delCount[i].type ){
          delCount[i].count = delCount[i].count++
          console.log(delCount[i].type,"type",delCount[i].count,delCount[i].count++)
        }
      }
      this.setDel('deleteCount',JSON.stringify(delCount))
      // localStorage.setItem("isDel",JSON.stringify(delCount))
      // if(type == 'estateHistoryList'){
      //   this.base = 'http://10.104.9.149:9400/'
      //   let url=this.base+'/estate/'
      //   window.parent.postMessage(localStorage.getItem('isDel'), url);
      // }else if(type == 'NewHistoryList'){
      //   console.log("????",type)
      //   this.base = 'http://10.104.9.149:9400/'
      //   let url=this.base
      //   window.parent.postMessage(localStorage.getItem('isDel'), url);
      // }else {
      //   let url=this.baseH
      //   window.parent.postMessage(localStorage.getItem('isDel'), url);
      // }
    },
    beforeClose(action, done) {
      let isDel = this.getDel('deleteCount')
      if(!isDel){
        // cookie中没有写入是否删除
        this.listCount()
      }
      // if(!localStorage.getItem('isDel')){
      //   console.log("ddsadfasd")
      //   this.listCount()
      // }
      if (action === 'confirm') {
        if (this.showTab === 1) {
          localStorage.removeItem('BuyHistoryList');
          this.countUp('BuyHistoryList')
          this.BuyHistoryList = [];
          this.buyNull = true;
        } else if (this.showTab === 2) {
          localStorage.removeItem('RentHistoryList');
          this.countUp('RentHistoryList')
          this.RentHistoryList = [];
          this.rentNull = true;
        } else if (this.showTab === 3) {
          localStorage.removeItem('NewHistoryList');
          this.countUp('NewHistoryList')
          this.NewHistoryList = [];
          this.newNull = true;
        } else {
          localStorage.removeItem('estateHistoryList');
          this.countUp('estateHistoryList')
          this.estateHistoryList = [];
          this.estNull = true;
        }
        this.showClearText();
        done();
      } else {
        done();
      }
    },
    newCollection(index, estateId, type) {
      const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      /** 判断是否登录 */
      if (!token) {
        /** 跳转登录页面 */
        const curLang = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
        location.href = location.origin + `/my/${curLang}login?referrer=` + location.href;
      } else {
        /** 收藏改页面 */
        this.addCollection(index, estateId, type);
      }
    },
    addCollection(index, estateId, type) {
      const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      let sorceTypeEst = '';
      if (type == 'est') {
        sorceTypeEst = 'estate';
      } else {
        sorceTypeEst = 'newEstate';
      }
      if (token) {
        this.axios
          .post(this.pub.getApi().AddCollection, {
            sourceID: estateId,
            sourceType: sorceTypeEst,
          })
          .then((res) => {
            // 一手新盘添加了收藏
            if (type == 'new') {
              this.NewHistoryList[index].collectionID = res.data.result;
              localStorage.setItem('NewHistoryList', JSON.stringify(this.NewHistoryList));
            } else {
              // 屋院添加了收藏
              this.estateHistoryList[index].collectionID = res.data.result;
              localStorage.setItem('estateHistoryList', JSON.stringify(this.estateHistoryList));
            }
          });
      }
    },
    cancelCollection(id, index, type) {
      let sorceTypeEst = '';
      if (type == 'est') {
        sorceTypeEst = 'Estate';
      } else {
        sorceTypeEst = 'newEstate';
      }
      this.axios
        .get(this.pub.getApi().DeleteCollection, {
          params: {
            collectionId: id,
            sourceType: sorceTypeEst,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            if (type == 'new') {
              this.NewHistoryList[index].collectionID = '';
              localStorage.setItem('NewHistoryList', JSON.stringify(this.NewHistoryList));
            } else {
              // 屋院
              this.estateHistoryList[index].collectionID = '';
              localStorage.setItem('estateHistoryList', JSON.stringify(this.estateHistoryList));
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.loading {
  font-size: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
/* 导航 */
.col-header {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  z-index: 4;
}
.col-header [class*='van-hairline']::after {
  border-bottom: 1px solid #e3e4e6;
}
.van-nav-bar {
  height: 44px;
  background-color: #fafbfc;
  border-bottom: 1px solid #e3e4e6;
}
.van-nav-bar__text {
  height: 44px;
  font-size: 15px;
  color: #333333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: #423f3f;
}
/* tab切换按钮 */
.col-tab {
  display: flex;
  width: 65%;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  border-radius: 100px;
  overflow: hidden;
  box-sizing: border-box;
  border: 0.5px solid rgba(41, 38, 48, 0.32);
}
.col-tab span {
  flex: 1;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0.18px;
  background-color: #fafbfc;
}
.col-tab span:not(:first-child) {
  box-sizing: border-box;
  border-left: 0.5px solid rgba(41, 38, 48, 0.32);
  border-right: 0.5px solid rgba(41, 38, 48, 0.32);
}
.col-tab .active {
  background-color: #333333;
  color: #ffffff;
}
/* 筛选按钮 */
/* .col-choice {
  opacity: 0.95;
  background-color: #001326;
  border-radius: 100px;
  width: 59px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  position: fixed;
  right: 17px;
  bottom: 101px;
  z-index: 2;
  box-sizing: border-box;
}
.col-choice .icon {
  color: #ffffff;
}*/
/* 筛选tab */
/* .choice-house {
  font-size: 14px;
  color: #151515;
  margin: 0 16px;
  height: 40px;
  line-height: 40px;
}
.choice-border {
  border-bottom: 1px solid #eeeeee;
}
.choice-active {
  color: #ed1c24;
} */
/* 无历史记录 */
.none-record {
  width: 100%;
  position: absolute;
  top: 52px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #ffffff;
}
.none-record p {
  font-size: 15px;
  color: #333333;
  margin: 0;
}
.none_col {
  width: 120px;
  height: 120px;
  margin: 82px auto 0;
}

/* 点击清除出现蒙版 */
.popup-clear {
  background-color: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
}
</style>
